// newPage/DataPage.js
import React, { useEffect } from 'react';
import SmartDataTable from '../../components/SmartDataTable';
import { useAuth } from '../../auth/auth-context';
import { getTableConfig } from './tableConfig';
import { useOrg } from './org-context';
import { getOrgPermissions } from './orgPermissions';

// export default function DataPage({ setMenuConfig }) {
export default function DataPage() {
  const { issuperadmin } = useAuth();
  const { memberships } = useOrg();

  const { canAddOrg } = getOrgPermissions({
    memberships,
    issuperadmin
  });


  const tableConfig = getTableConfig({ issuperadmin, canAddOrg, memberships });

    return (
        <div className="content-scrollable">
            <div className="page-title">Organization List</div>
            <SmartDataTable config={tableConfig} />
        </div>
    );
}
